import { gql } from "@apollo/client";

const GET_PRICE_LIST = gql`
  query getPriceList($articlePriceListId: Int!) {
    companyAdminContext {
      pricelists {
        getPriceList(articlePriceListId: $articlePriceListId) {
          articlePriceListId
          companyId
          description
          name
          rows {
            amount
            articlePriceListRowId
            artNo
            price
            productionCost
            shortDescription
            sortIndex
          }
        }
      }
    }
  }
`;

export default GET_PRICE_LIST;